<template>
    <loader-component v-if="showLoader"></loader-component>
    <div v-else>
        <!-- responsive-header -->
        <responsive-header-component></responsive-header-component>
        <!-- responsive-header -->

        <div class="wrapper default">

            <!-- header -->
            <header class="main-header default">
                <div class="container">
                    <header-component></header-component>
                </div>
                <!--<navbar-component></navbar-component>-->
            </header>
            <!-- header -->


            <main class="profile-user-page default">
                <div class="container" style="margin-top:10px;">
                    <div class="row">
                        <div class="profile-page col-xl-9 col-lg-8 col-md-12 order-2">
                            <router-view></router-view>
                        </div>
                        <div class="profile-page-aside col-xl-3 col-lg-4 col-md-6 center-section order-1">
                            <div class="profile-box">
                                <div class="profile-box-header">
                                    <div class="profile-box-avatar">
                                        <img src="/assets/img/svg/user.svg" alt="">
                                    </div>
                                    <button data-toggle="modal" data-target="#myModal" class="profile-box-btn-edit">
                                        <i class="fa fa-pencil"></i>
                                    </button>
                                </div>
                                <div class="profile-box-username">
                                    {{ userFullName }}<br />
                                    <div class="margin-t-5">
                                        <span class="modate-reg"> ({{ userName }}) </span><br />
                                        <span class="modate-reg">( نوع کاربر : {{ userGroup }}  )</span>
                                    </div>
                                </div>
                                <div class="profile-box-tabs">
                                    <!--<router-link to="/changePassword" class="profile-box-tab profile-box-tab-access">
                                        <i class="now-ui-icons ui-1_lock-circle-open"></i>
                                        تغییر رمز
                                    </router-link>-->
                                   <a @click="signOut" class="sign-out profile-box-tab profile-box-tab--sign-out">
                                        <i class="now-ui-icons media-1_button-power"></i>
                                        خروج از حساب
                                    </a>
                                </div>
                            </div>
                            <div class="responsive-profile-menu show-md">
                                <div class="btn-group">

                                    <button type="button" class="btn btn-secondary dropdown-toggle hesab-t" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fa fa-navicon"></i>
                                        منوی کاربری
                                    </button>
                                    <div class="dropdown-menu dropdown-menu-right text-right">

                                        <router-link to="/eduDrvSessions" class="dropdown-item" active-class="active-menu">
                                            <i class="now-ui-icons education_paper"></i>
                                            جلسات عملی رانندگی
                                        </router-link>
                                        

                                        <router-link to="/educatorAndCars" class="dropdown-item" active-class="active-menu">
                                            <i class="now-ui-icons ui-2_favourite-28"></i>
                                          مربیان و خودروها
                                        </router-link> 
                                        
                                    </div>
                                </div>
                            </div>
                            <div class="profile-menu hidden-md">
                                <div class="profile-menu-header">منوی کاربری</div>
                                <ul class="profile-menu-items">
                                    <li>
                                        <router-link to="/eduDrvSessions">
                                            <i class="now-ui-icons education_paper"></i>
                                            جلسات عملی رانندگی
                                        </router-link>
                                    </li> 
                                    <li v-if="userGroupId == 2">
                                        <router-link to="/educatorAndCars">
                                            <i class="now-ui-icons ui-2_favourite-28"></i>
                                            مربیان و خودروها
                                        </router-link>
                                    </li> 
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <!--<footer-component></footer-component>-->
        </div>

    </div>
</template>

<script>

    import { initialSite } from "../../module/initialSite"
    export default {
        data() {
            return {
                showLoader: false
            }
        },
        computed: {
            userFullName: function () {
                return this.$store.getters.readUserFullName;
            },
            userName: function () {
                return this.$store.getters.readUserName;
            },
            userGroup: function () {
                return this.$store.getters.readUserGroup;
            },
            userGroupId: function () {
                return this.$store.getters.readUserGroupId;
            },
            durationMembership: function () {
                return 0;
            }
            ,
            orderSuccessCount: function () {
                return 0;
            }
        },
        beforeMount: function () {
            initialSite(this);
        },
        methods: {
            signOut() {
                localStorage.removeItem('accessToken');
                //localStorage.removeItem('CartHashId');
                this.$store.commit('setUserFullName', '');
                this.isUserLogined = false;
                window.location.href = "/";
            }
        }
    }
</script>

<style scoped>
    .modate-reg {
        color: #bfa0a0;
        font-size: 14px;
        line-height: 1.9;
    }

    .sign-out {
        cursor: pointer;
    }

    @media only screen and (min-width: 0px) and (max-width: 640px) {
        main.profile-user-page .responsive-profile-menu .dropdown-toggle i {
            float: unset;
        }

        .hesab-t {
            width: 100%;
        }

        .btn-group, .btn-group-vertical {
            display: block;
        }
    }

    @media only screen and (min-width: 640px) and (max-width: 990px) {
        main.profile-user-page .responsive-profile-menu .dropdown-toggle i {
            float: unset;
        }

        .hesab-t {
            width: 100%;
        }

        .btn-group, .btn-group-vertical {
            display: block;
        }
    }
</style>